function initSearchTracking() {
    const newKeyword = document.getElementById('search_newkeyword') ? document.getElementById('search_newkeyword').dataset.value : null;
    const searchTerm = document.getElementById('gtm_search_term') ? document.getElementById('gtm_search_term').dataset.page : null;
    const alternativeKeywords = document.querySelectorAll('a.alternativeKeyword');

    window.dataLayer = window.dataLayer || [];

    if (alternativeKeywords.length) {
        alternativeKeywords.forEach(element => {
            element.addEventListener('click', function(event) {
                if (typeof window.google_tag_manager === 'object') {
                    const url = element.getAttribute('href');
                    event.preventDefault();

                    window.dataLayer.push({
                        'event': 'promoClick',
                        'eventTimeout': 1500,
                        'eventCallback': () => {
                            document.location = url;
                        },
                        'ecommerce': {
                            'promoClick': {
                                'promotions': [{
                                    'id': newKeyword,
                                    'name': 'Alternative Search Query',
                                    'creative': searchTerm,
                                    'position': 'SearchBar',
                                }],
                            },
                        },
                    });
                }
            });
        });
    }
}

export { initSearchTracking };
